import CONFIG from '../config/config';
import { instanceWithV2 as APIClient } from './SimpleAPIClient';
import type {
  BookingBackgroundMode,
  BookingBackgroundModeMobileConfig,
} from '../types/booking-background';

export type TabletConfig = {
  pin: string;
  catalogues: string[];
};

export type Config = {
  tenantId?: string,
  email?: string,
  phoneNumber?: string,
  brandName?: string,
  domain?: string,
  logoUrl?: string,
  websiteUrl?: string,
  timezone?: string,
  openingHours?: string,
  closingHours?: string,
  country?: string,
  shopId?: string,

  taxId?: string,
  companyName?: string,
  companyAddress?: string,
  companyPostalCode?: string,
  bankAccount?: string,

  deliveryAddress?: string,
  deliveryPostalCode?: string,

  currency?: string,

  primaryColor?: string,
  backgroundColor?: string,
  bookingBackgroundImageUrl?: string,
  bookingBackgroundImageUrlMobile?: string,
  bookingBackgroundMode?: BookingBackgroundMode,
  bookingBackgroundModeDesktop?: BookingBackgroundMode,
  bookingBackgroundModeMobile?: BookingBackgroundModeMobileConfig,

  mondayOpeningHours?: string,
  mondayClosingHours?: string,
  mondayClosed?: boolean,

  tuesdayOpeningHours?: string,
  tuesdayClosingHours?: string,
  tuesdayClosed?: boolean,

  wednesdayOpeningHours?: string,
  wednesdayClosingHours?: string,
  wednesdayClosed?: boolean,

  thursdayOpeningHours?: string,
  thursdayClosingHours?: string,
  thursdayClosed?: boolean,
  
  fridayOpeningHours?: string,
  fridayClosingHours?: string,
  fridayClosed?: boolean,

  saturdayOpeningHours?: string,
  saturdayClosingHours?: string,
  saturdayClosed?: boolean,

  sundayOpeningHours?: string,
  sundayClosingHours?: string,
  sundayClosed?: boolean,

  fittingRooms?: number,
  automaticallySendToPartners?: boolean,
  automaticallySendToProduction?: boolean,
  bookingLink?: string

  instagram?: string;

  allowedOrderStatuses?: string[];
  weddingRateReminderEnabled?: boolean;
  visitReminderChannel?: string | null;
  visitReminderDaysInAdvance?: number | null;
  autoSelectSingleBookingType?: boolean;
  hideBrandOnBookingPage?: boolean;
}

const ConfigAPI = {
  get: () => APIClient(CONFIG.API_ENDPOINT).get<Config>(`v1/configuration`),
  getTablet: () => APIClient(CONFIG.API_ENDPOINT).get<TabletConfig>(`v1/configuration/tablet`),
  update: (value: Config) => APIClient(CONFIG.API_ENDPOINT).put<Config>(`v1/configuration`, value),
  updateTablet: (value: TabletConfig) => APIClient(CONFIG.API_ENDPOINT).put<Config>(`v1/configuration/tablet`, value),
};

export default ConfigAPI;
